import { Pipe, PipeTransform } from '@angular/core';
import { HighlightMatchTextHelper } from '@zaoblako/web/shared/helpers/highlight-match-text.helper';

@Pipe({
  standalone: true,
  name: 'highlightMatch'
})
export class HighlightMatchPipe implements PipeTransform {
  public transform(text: string | null | undefined, filterValue?: string | null): string {
    const source = text ?? '';
    const filter = filterValue ?? '';
    if (!source) {
      return '';
    }
    if (!filter.length) {
      return source.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    return HighlightMatchTextHelper.highlightMatchText(source, filter);
  }
}
